<template>
  <span>
    <template v-if="Number(displayPrice.discount) > 0">
      <span class="discounted-price">
        ${{ Number(displayPrice.discountedProductPrice).toFixed(2) }}
        <template v-if="Number(price.termMonth) > 0">
          (${{ Number(displayPrice.discountedProductPriceMonthly).toFixed(2) }}/month)
        </template>
        <span class="promo-label">{{ price.discountName }}</span>
      </span>
      <span v-if="price.renewalPrice !== null && price.renewalPrice !== undefined
        && Number(price.termMonth) > 0" class="renewal-price">
        Renewal ${{ Number(displayPrice.renewalPrice).toFixed(2) }}
        (${{ Number(displayPrice.renewalPriceMonthly).toFixed(2) }}/month)
      </span>
    </template>
    <template v-else>
      ${{ Number(displayPrice.productPrice).toFixed(2) }}
      <template v-if="Number(price.termMonth) > 0">
        (${{ Number(displayPrice.productPriceMonthly).toFixed(2) }}/month)
      </template>
    </template>
  </span>
</template>

<script>
import { serviceDisplayPrice } from '../../plugins/registration-gst';

export default {
  name: 'RegistrationPrice',
  props: {
    price: { type: Object, required: true },
    includeGst: { type: Boolean, default: true },
  },
  computed: {
    displayPrice() { return serviceDisplayPrice(this.price, this.includeGst); },
  },
};
</script>

<style scoped>
.discounted-price {
  color: #FF670D;
  font-weight: 600;
}
.promo-label {
  white-space: nowrap;
}
.renewal-price {
  display: block;
}
</style>
